/* Adapt PDP "Find someone like you" stories (2026-10-05). Tap a person, read their story. Deep links: #story-valerie (a first name) opens that story, so an ad can land on the matching life. Arrow keys move between people; swiping a story moves to the next/previous person. Nothing autoplays and nothing here ever scrolls the PAGE (only the picker row scrolls sideways). Loaded with defer by sections/pdp-review-spotlight.liquid. */
(function(){
  document.querySelectorAll('[data-st]').forEach(function(root){
    root.classList.add('has-js');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-st-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-st-panel]'));
    var row = root.querySelector('[data-st-tabs]');
    var stage = root.querySelector('[data-st-stage]');
    if(!tabs.length || tabs.length !== panels.length) return;
    var cur = 0;

    function centerTab(t, instant){
      if(!row || row.scrollWidth <= row.clientWidth + 2) return;
      var r = row.getBoundingClientRect(), b = t.getBoundingClientRect();
      var left = b.left - r.left + row.scrollLeft - (row.clientWidth - t.offsetWidth) / 2;
      try { row.scrollTo({ left: left, behavior: instant ? 'auto' : 'smooth' }); } catch(e) { row.scrollLeft = left; }
    }

    function show(n, opts){
      opts = opts || {};
      n = Math.max(0, Math.min(tabs.length - 1, n));
      cur = n;
      tabs.forEach(function(t, i){
        var on = i === n;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function(p, i){ p.classList.toggle('is-on', i === n); });
      centerTab(tabs[n], opts.instant);
      if(opts.focus){ try { tabs[n].focus({ preventScroll: true }); } catch(e) { tabs[n].focus(); } }
      if(opts.hash && window.history && history.replaceState){
        try { history.replaceState(null, '', '#' + tabs[n].id); } catch(e) {}
      }
    }

    tabs.forEach(function(t, i){
      t.addEventListener('click', function(){ show(i, { hash: true }); });
      t.addEventListener('keydown', function(e){
        if(e.key === 'ArrowRight'){ e.preventDefault(); show(i + 1, { focus: true, hash: true }); }
        else if(e.key === 'ArrowLeft'){ e.preventDefault(); show(i - 1, { focus: true, hash: true }); }
        else if(e.key === 'Home'){ e.preventDefault(); show(0, { focus: true, hash: true }); }
        else if(e.key === 'End'){ e.preventDefault(); show(tabs.length - 1, { focus: true, hash: true }); }
      });
    });

    if(stage){
      var x0 = null, y0 = null;
      stage.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function(e){
        if(x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null; y0 = null;
        if(Math.abs(dx) > 70 && Math.abs(dx) > Math.abs(dy) * 1.8){
          show(cur + (dx < 0 ? 1 : -1), { hash: true });
        }
      }, { passive: true });
    }

    function fromHash(){
      var id = (window.location.hash || '').replace('#', '');
      if(!id) return false;
      for(var i = 0; i < tabs.length; i++){
        if(tabs[i].id === id){ show(i, { instant: true }); return true; }
      }
      return false;
    }
    if(!fromHash()) show(0, { instant: true });
    window.addEventListener('hashchange', fromHash);
  });
})();